import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Opens the Bootstrap modal on page load when the configured query-string
// parameter is present and equals "true". Replaces the legacy jQuery
// $modal.modal("show") call, which relied on Bootstrap 4's jQuery plugin API
// that no longer exists in Bootstrap 5.
//
// Usage:
//   <div class="modal" data-controller="modal-on-load"
//        data-modal-on-load-param-value="show_new_profile_modal">
export default class extends Controller {
  static values = { param: String };

  connect() {
    const requestedValue = new URLSearchParams(window.location.search).get(this.paramValue);
    if (requestedValue !== "true") return;

    Modal.getOrCreateInstance(this.element).show();
  }
}
